import type { UserResponse, UserWhisperResponse } from '@1webit/cvs-api-scheme';
import dayjs from 'dayjs';

import { dayjsCs } from '@/utils/dayjsCs';

export const validatePersonalIdentificationNumber = (personalIDNumber: string, dateOfBirth: Date): string | true => {
  if (!personalIDNumber.includes('/')) {
    return 'Rodné číslo musí obsahovat lomítko';
  }

  const [prefix, suffix] = personalIDNumber.split('/');
  if (!prefix || !suffix) {
    return 'Rodné číslo musí být rozděleno lomítkem';
  }

  const fullNumber = prefix + suffix;

  if (fullNumber.length !== 10 && fullNumber.length !== 9) {
    return 'Neplatná délka rodného čísla';
  }

  const year = Number.parseInt(prefix.slice(0, 2), 10);
  const month = Number.parseInt(prefix.slice(2, 4), 10);
  const day = Number.parseInt(prefix.slice(4, 6), 10);

  const currentYear = new Date().getFullYear() % 100;
  const actualYear = year + (year > currentYear ? 1900 : 2000);
  const actualMonth = month > 50 ? month - 50 : month;

  const dob = dayjs(dateOfBirth);

  if (dob.year() !== actualYear || dob.month() + 1 !== actualMonth || dob.date() !== day) {
    return 'Rodné číslo neodpovídá datumu narození';
  }

  if (actualYear < 1954 && fullNumber.length === 9) {
    return true;
  }

  if (fullNumber.length === 10 && Number.parseInt(fullNumber, 10) % 11 !== 0) {
    return 'Neplatné rodné číslo';
  }

  return true;
};

export const formatPersonDetails = (person: UserResponse | UserWhisperResponse | undefined) => {
  if (!person) {
    return '';
  }

  return [
    person.lastName,
    person.firstName,
    person.dateOfBirth ? `(${dayjsCs(person.dateOfBirth).format('YYYY')})` : '',
    person.note,
  ].filter(Boolean).join(' ');
};
